import Vue from "vue";
import "./bootstrap";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import { isLoggedIn } from "./config/auth";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import VueRouter from "vue-router";

// import axios from 'axios'
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import VuePaginate from "vue-paginate";
import "vuetify/dist/vuetify.min.css";
import Vuetify from "vuetify";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Multiselect from "vue-multiselect";
import VueDraggable from "vue-draggable";
import VueBarcode from "vue-barcode";
import CanvasJSChart from '@canvasjs/vue-charts';

// GOOGLE
import VueGapi from "vue-gapi";

library.add(faUserSecret);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("multiselect", Multiselect);

// window.axios = axios
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
// window.axios.defaults.baseURL = process.env.VUE_APP_URL

// Vue.prototype.$axios = axios;

Vue.use(CanvasJSChart);
Vue.use(VueBarcode);
Vue.use(VueRouter);
Vue.use(VueSweetalert2);
Vue.use(VuePaginate);
Vue.use(VueDraggable);
Vue.use(Multiselect);
Vue.use(Vuetify);


Vue.use(VueGapi, {
  clientId: "65945898773-sqkg4q7mgf7333d27mddeet76qu99l3t.apps.googleusercontent.com",
  scope: "profile email",
  prompt: "select_account",
});

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.isPublic) && !isLoggedIn()) {
    next({
      path: "404",
      query: { redirect: to.fullPath }
    });
  } else {
    const nearestWithTitle = to.matched
      .slice()
      .reverse()
      .find(record => record.meta && record.meta.title);

    if (nearestWithTitle) {
      document.title = to.meta.title;
      document.getElementsByTagName('meta')["description"].content = to.meta.description;
      if (to.meta.canonical)
        document.getElementsByTagName('link')["canonical"].href = "https://havolinemotoclub.com/" + to.meta.canonical;
      else
        document.getElementsByTagName('link')["canonical"].href = "https://havolinemotoclub.com" + to.fullPath;

      // Agregar etiqueta canonical para la versión con "www"
      // const canonicalUrlWithWWW = "https://www.havolinemotoclub.com" + to.fullPath;
      // const linkWithWWW = document.createElement('link');
      // linkWithWWW.setAttribute('rel', 'canonical');
      // linkWithWWW.setAttribute('href', canonicalUrlWithWWW);
      // document.head.appendChild(linkWithWWW);

      if (window.location.hostname.startsWith('www.')) {
        window.location.href = window.location.href.replace('www.', '');
      }
    }
    next();
  }
});

new Vue({
  store,
  router,
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount("#app");
